import React from 'react';

const JS_Logical = () => {
  return (
    <div >
      <h1>JS_Logical</h1>
      <p>Placeholder component for: "JS Logical"</p>
    </div>
  );
};

export default JS_Logical;
